module.exports = __webpack_public_path__ + "static/media/_MIC2572.image.6ae63f0e.png";